import { render, staticRenderFns } from "./Section.vue?vue&type=template&id=46053308&scoped=true&"
var script = {}
import style0 from "./Section.vue?vue&type=style&index=0&id=46053308&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46053308",
  null
  
)

export default component.exports